import { createApp } from 'vue';
import MainApp from './MainApp.vue';

createApp(MainApp).mount('#app');
